<template>
  <div>
    <div class="section-chart">
      <div class="container">
        <div class="div-flex">
          <div class="col-left">
            <label>PRIZE</label>
          </div>
          <div class="col-right txt-right">
            <div class="dropdown-inline">
              <!-- New dropdown for General/Days - only shows for SERIES -->
              <select
                v-if="eventData?.event_prize_money?.templateType === 'SERIES'"
                v-model="selectedType"
                class="inline-dropdown"
              >
                <option value="overall">General</option>
                <option value="day">Stage</option>
              </select>

              <select v-model="selectedCategory" class="inline-dropdown">
                <option
                  v-for="(category, cat) of categories"
                  :key="cat"
                  :value="category.value"
                >
                  {{ category.label }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <!--tabs start-->
        <div class="tab-chart-wrpr">
          <div class="container" style="padding: 0px">
            <div class="tab-chart">
              <button
                v-for="(heading, h) of categoryWinners"
                :key="h"
                :class="h === 0 ? ' active tablinks-btn' : 'tablinks-btn'"
                @click="openChart($event, convertToSlug(heading.heading))"
              >
                {{ heading.heading }}
              </button>
            </div>

            <div
              v-for="(winners, w) of categoryWinners"
              :id="convertToSlug(winners.heading)"
              :key="w"
              :class="w === 0 ? ' block' : ''"
              class="tab-chartcontent"
            >
              <div class="chart-bar-wrpr">
                <div
                  class="bar-position-2"
                  :class="
                    topThreeWinners(winners.winners)[2] ? '' : 'disable-bar'
                  "
                >
                  <p class="prize">{{ topThreeWinners(winners.winners)[2] }}</p>
                  <h1>2<span>nd</span></h1>
                </div>
                <div
                  class="bar-position-1"
                  :class="
                    topThreeWinners(winners.winners)[1] ? '' : 'disable-bar'
                  "
                >
                  <p class="prize">{{ topThreeWinners(winners.winners)[1] }}</p>
                  <h1>1<span>st</span></h1>
                </div>
                <div
                  class="bar-position-3"
                  :class="
                    topThreeWinners(winners.winners)[3] ? '' : 'disable-bar'
                  "
                >
                  <p class="prize">{{ topThreeWinners(winners.winners)[3] }}</p>
                  <h1>3<span>rd</span></h1>
                </div>
              </div>
              <div class="list-prize">
                <ul>
                  <li
                    v-for="(rWinner, rw) in remainingWinners(winners.winners)"
                    :key="rw"
                  >
                    <span class="num"
                      >{{ rw.replace("winner_", "") }}
                      <div class="pos-number">th</div></span
                    ><span class="money">{{ rWinner }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!--tabs end-->
      </div>
    </div>
    <EventLinks :links="getLinks" :new_version="true" v-if="showLink" />
  </div>
</template>

<script>
import { commonMixin } from "@/mixins/commonMixin";
import EventLinks from "@/components/event/EventLinks";

export default {
  name: "PriceWidget",
  components: { EventLinks },
  props: ["winners", "eventData", "showLink"],
  mixins: [commonMixin],

  data() {
    return {
      categories: [],
      firstCategory: "general",
      selectedCategory: "general",
      selectedType: "overall",
    };
  },
  computed: {
    categoryWinners() {
      const prizeData = this.eventData?.event_prize_money;

      if (!prizeData) return [];

      // For SERIES type, use selectedType (overall/days), for SRC use categories
      let categoryData, headings;

      if (prizeData.templateType === "SERIES") {
        // Use overall or day_headings based on selectedType
        categoryData = prizeData[this.selectedType]; // prizeData.overall or prizeData.days
        headings =
          this.selectedType === "overall"
            ? prizeData.overall_headings
            : prizeData.day_headings;
      } else {
        // For SRC type, use the old categories structure
        categoryData = prizeData.categories?.[this.selectedCategory];
        headings = prizeData.headings;
      }

      if (!categoryData || !Array.isArray(headings)) return [];

      const currency = prizeData.currency || "AED";
      const conversionRate = prizeData.conversionRate || 1;
      const isUSD = currency === "USD";

      const data = [];

      // Loop through headings in exact order
      headings.forEach(({ gateType, heading }) => {
        // Skip segments for SERIES template type
        if (prizeData.templateType === "SERIES" && gateType === "segments") {
          return;
        }

        // For SERIES, categoryData[selectedCategory][gateType]
        // For SRC, categoryData[gateType]
        const gateData =
          prizeData.templateType === "SERIES"
            ? categoryData?.[this.selectedCategory]?.[gateType]
            : categoryData?.[gateType];

        if (!gateData?.prizes?.length) return;

        const winnerData = {};

        gateData.prizes.forEach((prize, index) => {
          let formattedPrize = isUSD ? prize / conversionRate : prize;
          formattedPrize = Math.round(formattedPrize * 100) / 100;

          winnerData[
            `winner_${index + 1}`
          ] = `${currency} ${formattedPrize.toLocaleString()}`;
        });

        data.push({
          heading,
          category: this.selectedCategory,
          winners: winnerData,
        });
      });

      return data;
    },
    getLinks() {
      return this.eventData.links;
    },
  },

  mounted() {
    this.getCategories();
  },

  watch: {
    categories(v) {
      if (v.length > 0) {
        this.selectedCategory = v[0].value;
      }
    },
    selectedType() {
      // Refresh categories when type changes
      this.getCategories();
    },
    categoryWinners() {
      // Activate first tab when category winners change
      this.activateFirstTab();
    },
  },

  methods: {
    activateFirstTab() {
      this.$nextTick(() => {
        // Hide all tab contents
        const tabContents = document.getElementsByClassName("tab-chartcontent");
        for (let i = 0; i < tabContents.length; i++) {
          tabContents[i].style.display = "none";
        }

        // Remove active class from all tabs
        const tabButtons = document.getElementsByClassName("tablinks-btn");
        for (let i = 0; i < tabButtons.length; i++) {
          tabButtons[i].className = tabButtons[i].className.replace(
            " active",
            ""
          );
        }

        // Activate first tab if it exists
        if (tabButtons.length > 0 && tabContents.length > 0) {
          tabButtons[0].className += " active";
          tabContents[0].style.display = "block";
        }
      });
    },
    convertToSlug(text) {
      if (!text) return;
      return text
        .toLowerCase()
        .replace(/ /g, "-")
        .replace(/[^\w-]+/g, "");
    },

    topThreeWinners(winners) {
      return {
        1: winners.winner_1,
        2: winners.winner_2,
        3: winners.winner_3,
      };
    },

    getCategories() {
      const categories = [];
      const prizeData = this.eventData?.event_prize_money;

      if (!prizeData) {
        categories.push({ value: "general", label: "General" });
        this.categories = categories;
        return;
      }

      if (prizeData.templateType === "SERIES") {
        // For SERIES, get categories from overall or days based on selectedType
        const dataSource = prizeData[this.selectedType];
        if (dataSource) {
          Object.keys(dataSource).forEach((categoryKey) => {
            categories.push({
              value: categoryKey,
              label: `Category ${categoryKey}`,
            });
          });
        }
      } else {
        // For SRC, use the old categories structure
        if (prizeData.categories) {
          Object.keys(prizeData.categories).forEach((categoryKey) => {
            categories.push({
              value: categoryKey,
              label: `Category ${categoryKey}`,
            });
          });
        }
      }

      // If no categories found, add default
      if (categories.length === 0) {
        categories.push({ value: "general", label: "General" });
      }

      this.categories = categories;
    },

    remainingWinners(winners) {
      // Create a copy of the winners object
      const copy = { ...winners };

      // Remove the first three winners and any non-winner properties
      delete copy.winner_1;
      delete copy.winner_2;
      delete copy.winner_3;

      return copy;
    },

    openChart(evt, cityName) {
      var i, tabContent, tablinks;
      tabContent = document.getElementsByClassName("tab-chartcontent");
      for (i = 0; i < tabContent.length; i++) {
        tabContent[i].style.display = "none";
      }
      tablinks = document.getElementsByClassName("tablinks-btn");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }
      document.getElementById(cityName).style.display = "block";
      evt.currentTarget.className += " active";
    },
  },
};
</script>

<style scoped>
.default-heading {
  font-size: 34px !important;
}

.nav-tabs .nav-item {
  width: 100%;
}

.prize-section .nav-tabs .nav-link {
  border-bottom: 1px solid wheat;
}

.prize-section .list-inline-item:not(:last-child) {
  margin-right: 60px;
}

.prize-section .stretch-list .list-inline-item:not(:last-child) {
  padding: 0 20px;
}

.block {
  display: block;
}

/* New styles to fix layout and overlapping */
.dropdown-container {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}

.type-dropdown,
.category-dropdown {
  min-width: 150px;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: white;
}

.bar-position-1,
.bar-position-2,
.bar-position-3 {
  position: relative;
  min-height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
}

.bar-position-1 .prize,
.bar-position-2 .prize,
.bar-position-3 .prize {
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  background: transparent;
  padding: -1px 8px;
  border-radius: 4px;
  font-weight: bold;
  white-space: nowrap;
  z-index: 10;
  color: #333;
  font-size: 25px;
  text-align: center;
  min-width: max-content;
}

.chart-bar-wrpr {
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 30px;
  margin-bottom: 20px;
  padding: 50px 20px 20px 20px; /* Increased top padding for prize text */
}

@media (max-width: 768px) {
  .dropdown-container {
    flex-direction: column;
    align-items: stretch;
  }

  .type-dropdown,
  .category-dropdown {
    width: 100%;
  }
}

.dropdown-inline {
  display: inline-flex;
  gap: 10px;
  align-items: center;
}

.inline-dropdown {
  display: inline-block;
  min-width: 150px;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: white;
}

/* Add these responsive styles to the existing CSS: */

@media (max-width: 768px) {
  .dropdown-inline {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }

  .inline-dropdown {
    width: 100%;
    min-width: unset;
  }

  .div-flex {
    flex-direction: column;
    gap: 15px;
  }

  .col-left {
    text-align: center;
  }

  .col-right {
    text-align: center !important;
  }

  .chart-bar-wrpr {
    gap: 15px;
    padding: 40px 10px 15px 10px;
    overflow-x: auto;
  }

  .bar-position-1,
  .bar-position-2,
  .bar-position-3 {
    min-width: 80px;
    min-height: 80px;
  }

  .bar-position-1 .prize,
  .bar-position-2 .prize,
  .bar-position-3 .prize {
    font-size: 14px;
    top: -35px;
    padding: 2px 4px;
  }

  .tab-chart {
    overflow-x: auto;
    white-space: nowrap;
    padding-bottom: 10px;
  }

  .tablinks-btn {
    display: inline-block;
    margin-right: 10px;
    min-width: max-content;
  }

  .list-prize ul {
    padding: 0 10px;
  }

  .list-prize li {
    padding: 8px 0;
    border-bottom: 1px solid #eee;
  }
}

@media (max-width: 480px) {
  .chart-bar-wrpr {
    gap: 10px;
    padding: 35px 5px 10px 5px;
  }

  .bar-position-1,
  .bar-position-2,
  .bar-position-3 {
    min-width: 60px;
    min-height: 60px;
  }

  .bar-position-1 .prize,
  .bar-position-2 .prize,
  .bar-position-3 .prize {
    font-size: 12px;
    top: -30px;
  }

  .bar-position-1 h1,
  .bar-position-2 h1,
  .bar-position-3 h1 {
    font-size: 18px;
  }

  .tablinks-btn {
    font-size: 12px;
    padding: 8px 12px;
  }

  .money {
    font-size: 20px !important;
  }
}
</style>
